




// import React from "react";
// import ApplicationheroImage from "../../../../assets/solutions/applicationdevelopment/ApplicationDevelopment.png";
// import "../styles/ApplicationHero.css";

// const ApplicationHero = () => {
//   return (
//     <section className="hero-section">
//       <div className="hero-container">
//         {/* Left Side: Text Details */}
//         <div className="hero-details">
//           <div className="badge-status">
//             <span className="node-pulse"></span>
//             ENGINEERING CORE: ACTIVE
//           </div>
          
//           <h2>Modernize for <br />Unlimited Scale.</h2>
          
//           <p className="lede-text">
//             We build the software foundations that fuel business growth.
//           </p>
          
//           <p>
//             At Synectiks, we transform outdated legacy burdens into high-performance 
//             digital engines. Our engineering excellence ensures your core platforms 
//             are secure, fast, and ready for future innovation.
//           </p>
//         </div>

//         {/* Right Side: Morphing SVG Blob */}
//         <div className="hero-graphic">
//           <svg viewBox="0 0 200 200" className="morph-svg" xmlns="http://www.w3.org/2000/svg">
//             <defs>
//               <linearGradient id="primary-grad" x1="0" x2="1" y1="0" y2="1">
//                 <stop offset="0%" stopColor="#0B63F6" />
//                 <stop offset="100%" stopColor="#22d3ee" />
//               </linearGradient>
//             </defs>
//             <path 
//               fill="url(#primary-grad)"
//               d="M47.7,-64.5C59.9,-54.3,66.5,-37.2,68.9,-20.5C71.3,-3.8,69.5,12.5,62.7,27.1C55.9,41.7,44.1,54.6,29.9,62.1C15.8,69.5,-0.7,71.5,-16.9,67.6C-33.1,63.7,-48.9,53.8,-59.4,39.9C-69.8,26,-74.9,8,-72,-8.6C-69.1,-25.1,-58.2,-40.1,-44.6,-50C-31.1,-59.8,-15.5,-64.5,1.5,-66.6C18.4,-68.7,35.5,-74.7,47.7,-64.5Z"
//               transform="translate(100 100)" 
//             />
//           </svg>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ApplicationHero;











// import React from "react";
// import ApplicationheroImage from "../../../../assets/solutions/applicationdevelopment/ApplicationDevelopment.png";
// import "../styles/ApplicationHero.css";

// const ApplicationHero = () => {
//   return (
//     <section className="hero-section">
//       <div className="hero-container">
//         {/* Left Side: Text Details */}
//         <div className="hero-details">
//           <div className="badge-status">
//             <span className="node-pulse"></span>
//             ENGINEERING CORE: ACTIVE
//           </div>
          
//           <h2>Modernize for <br />Unlimited Scale.</h2>
          
//           <p className="lede-text">
//             We build the software foundations that fuel business growth.
//           </p>
          
//           <p>
//             At Synectiks, we transform outdated legacy burdens into high-performance 
//             digital engines. Our engineering excellence ensures your core platforms 
//             are secure, fast, and ready for future innovation.
//           </p>
//         </div>

//         {/* Right Side: Morphing SVG Blob with Image Overlay */}
//         <div className="hero-graphic">
//           <svg viewBox="0 0 200 200" className="morph-svg" xmlns="http://www.w3.org/2000/svg">
//             <defs>
//               <linearGradient id="primary-grad" x1="0" x2="1" y1="0" y2="1">
//                 <stop offset="0%" stopColor="#0B63F6" />
//                 <stop offset="100%" stopColor="#22d3ee" />
//               </linearGradient>

//               {/* The ClipPath: This defines the "stencil" that cuts the image */}
//               <clipPath id="blob-clip">
//                 <path d="M47.7,-64.5C59.9,-54.3,66.5,-37.2,68.9,-20.5C71.3,-3.8,69.5,12.5,62.7,27.1C55.9,41.7,44.1,54.6,29.9,62.1C15.8,69.5,-0.7,71.5,-16.9,67.6C-33.1,63.7,-48.9,53.8,-59.4,39.9C-69.8,26,-74.9,8,-72,-8.6C-69.1,-25.1,-58.2,-40.1,-44.6,-50C-31.1,-59.8,-15.5,-64.5,1.5,-66.6C18.4,-68.7,35.5,-74.7,47.7,-64.5Z" transform="translate(100 100)" />
//               </clipPath>
//             </defs>

//             {/* 1. The Background Colored Blob */}
//             <path 
//               fill="url(#primary-grad)"
//               d="M47.7,-64.5C59.9,-54.3,66.5,-37.2,68.9,-20.5C71.3,-3.8,69.5,12.5,62.7,27.1C55.9,41.7,44.1,54.6,29.9,62.1C15.8,69.5,-0.7,71.5,-16.9,67.6C-33.1,63.7,-48.9,53.8,-59.4,39.9C-69.8,26,-74.9,8,-72,-8.6C-69.1,-25.1,-58.2,-40.1,-44.6,-50C-31.1,-59.8,-15.5,-64.5,1.5,-66.6C18.4,-68.7,35.5,-74.7,47.7,-64.5Z" 
//               transform="translate(100 100)" 
//             />

//             {/* 2. The Person Image: clipped by the blob shape */}
//             <image
//               href={ApplicationheroImage}
//               x="-15"
//               y="-37" 
//               width="230"
//               height="260"
//               clipPath="url(#blob-clip)"
//               className="person-img"
//             />
//           </svg>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ApplicationHero;











import React from "react";
import ApplicationheroImage from "../../../../assets/solutions/applicationdevelopment/ApplicationDevelopment.png";
import "../styles/ApplicationHero.css";

const ApplicationHero = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        {/* Left Side: Text Details */}
        <div className="hero-details">
          <div className="badge-status">
            <span className="node-pulse"></span>
            ENGINEERING CORE: ACTIVE
          </div>
          
          <h2>Modernize for <br />Unlimited Scale.</h2>
          
          <p className="lede-text">
            We build the software foundations that fuel business growth.
          </p>
          
          <p>
            At Synectiks, we transform outdated legacy burdens into high-performance 
            digital engines. Our engineering excellence ensures your core platforms 
            are secure, fast, and ready for future innovation.
          </p>
        </div>

        {/* Right Side: Morphing SVG Blob with 3D Image Overlay */}
        <div className="hero-graphic">
          <svg viewBox="0 0 200 200" className="morph-svg" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="primary-grad" x1="0" x2="1" y1="0" y2="1">
                <stop offset="0%" stopColor="#0B63F6" />
                <stop offset="100%" stopColor="#22d3ee" />
              </linearGradient>

              {/* Clip 1: The Blob (cuts the bottom) */}
              <clipPath id="blob-clip">
                <path d="M47.7,-64.5C59.9,-54.3,66.5,-37.2,68.9,-20.5C71.3,-3.8,69.5,12.5,62.7,27.1C55.9,41.7,44.1,54.6,29.9,62.1C15.8,69.5,-0.7,71.5,-16.9,67.6C-33.1,63.7,-48.9,53.8,-59.4,39.9C-69.8,26,-74.9,8,-72,-8.6C-69.1,-25.1,-58.2,-40.1,-44.6,-50C-31.1,-59.8,-15.5,-64.5,1.5,-66.6C18.4,-68.7,35.5,-74.7,47.7,-64.5Z" transform="translate(100 100)" />
              </clipPath>

              {/* Clip 2: The Top Half (allows head/hands to pop out) */}
              <clipPath id="top-popout">
                <rect x="-30" y="-70" width="300" height="200" />
              </clipPath>
            </defs>

            {/* 1. The Background Colored Blob */}
            <path 
              fill="url(#primary-grad)"
              d="M47.7,-64.5C59.9,-54.3,66.5,-37.2,68.9,-20.5C71.3,-3.8,69.5,12.5,62.7,27.1C55.9,41.7,44.1,54.6,29.9,62.1C15.8,69.5,-0.7,71.5,-16.9,67.6C-33.1,63.7,-48.9,53.8,-59.4,39.9C-69.8,26,-74.9,8,-72,-8.6C-69.1,-25.1,-58.2,-40.1,-44.6,-50C-31.1,-59.8,-15.5,-64.5,1.5,-66.6C18.4,-68.7,35.5,-74.7,47.7,-64.5Z" 
              transform="translate(100 100)" 
            />

            {/* 2. Bottom Layer Image: Cut by Blob shape */}
            <image
              href={ApplicationheroImage}
              x="-15" y="-37" width="230" height="260"
              clipPath="url(#blob-clip)"
              className="person-img"
            />

            {/* 3. Top Layer Image: Overflows the top of the blob */}
            <image
              href={ApplicationheroImage}
              x="-15" y="-37" width="230" height="260"
              clipPath="url(#top-popout)"
              className="person-img"
            />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default ApplicationHero;